import React from 'react';

export const HOMEPAGE_HERO_RESERVATION =
  'min-h-[calc(50vw+320px)] lg:min-h-[560px]';
export const HOMEPAGE_HERO_TEXT_RESERVATION = 'max-lg:min-h-[320px]';

const HomepageHeroPlaceholder = () => (
  <div
    aria-hidden="true"
    className={`${HOMEPAGE_HERO_RESERVATION} bg-gray-light2 animate-pulse`}
    data-xc="homepage-hero-placeholder"
  />
);

export default HomepageHeroPlaceholder;
